import { FC, lazy, Suspense } from 'react';
import { Spin } from 'antd';
import type { LazyExoticComponent } from 'react';
import { useRouteError } from 'react-router-dom';

const lazyView = (view: JSX.Element) => {
  return (
    <Suspense
      fallback={
        <Spin tip="Loading..." size="large">
          <div className="loading-container"></div>
        </Spin>
      }
    >
      {view}
    </Suspense>
  );
};
const lazyComponent = (
  jsxElement:
    | string
    | LazyExoticComponent<FC>
    | LazyExoticComponent<() => JSX.Element>
): JSX.Element => {
  const Module = jsxElement;
  return lazyView(<Module />);
};
export const RootErrorBoundary = () => {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
};
export const Icon = (url: string) => {
  return <img src={url} alt="" height={24} width={24} />;
};

const staticMenus = [
  {
    title: 'Home',
    path: 'index',
    element: lazyComponent(lazy(() => import('@/views/Home'))),
    isDefault: true
  },
  {
    title: '404',
    path: '*',
    element: lazyComponent(lazy(() => import('@/views/NotFound')))
  },
  {
    title: 'Article',
    path: 'article/:slug',
    element: lazyComponent(lazy(() => import('@/views/Article')))
  }
];

// eslint-disable-next-line react-refresh/only-export-components
export { staticMenus };
